<div class="flex justify-center items-center h-[100vh] p-5">
  <div class="lock"></div>
  <div class="flex flex-col justify-center ml-14">
    <h1>You're not authorized to access this page!</h1>
    <h5>Please check with the site admin if you believe this is a mistake.</h5>
    <button pButton label="Go Back" type="button" icon="pi pi-arrow-left" class="p-button-secondary p-button-outlined mt-4 self-center" (click)="goBack()"></button>
  </div>
</div>
